<template>
    <DefaultLayout>
        <DashboardSection />
    </DefaultLayout>
</template>

<script>
import { canAccessPage } from "@/routeAcl.js";
import DashboardSection from '@/components/dashboard/DashboardSection.vue';

export default {
    components: {
        DashboardSection,
    },
    data() {
        return {}
    },
    mounted() {
        api.auth().then((user) => {
            this.$root.loggedUser = user;

            if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
                this.$router.push({ name: 'Index', });
                return;
            }
        });
    },
};
</script>
